import {inject, injectable} from 'inversify';

import type {CardApiModel} from '../../../../api/payment';
import type {Expand, Expanded, MaybeExpanded} from '../../../../api/types';
import type {CourseMapperJrpc} from '../../Course/mappers/Course.mapper.jrpc';
import type {OfferMapperJrpc} from '../../Offer/mappers/Offer.mapper.jrpc';
import type {RefundMapperJrpc} from '../../Refund/mappers/Refund.mapper.jrpc';
import type {UserMapperJrpc} from '../../User/mappers/User.mapper.jrpc';

import {EnvProviderService} from '../../../system/env/EnvProvider.service';
import {BaseExpandJrpc} from '../../Base/mappers/Base.expand.jrpc';
import {CourseExpandJrpc} from '../../Course/mappers/Course.expand.jrpc';
import {OfferExpandJrpc} from '../../Offer/mappers/Offer.expand.jrpc';
import {UserExpandJrpc} from '../../User/mappers/User.expand.jrpc';

@injectable()
export class PaymentExpandJrpc extends BaseExpandJrpc {
  constructor(
    @inject(EnvProviderService) env: EnvProviderService,
    @inject(UserExpandJrpc) private userExpand: UserExpandJrpc,
    @inject(CourseExpandJrpc) private courseExpand: CourseExpandJrpc,
    @inject(OfferExpandJrpc) private offerExpand: OfferExpandJrpc,
  ) {
    super(env);
  }

  getByEnv(key?: BaseExpandJrpc.EnvKey): Expand {
    const base: Expand = {
      payment: [
        ['course_id', null, this.courseExpand.getByEnv(key)],
        ['user_id', {name: 'User not found'}, this.userExpand.getByEnv(key)],
        ['refund_ids', null, {refund: ['refund_payment_id']}],
        ['offer_id', null, this.offerExpand.getByEnv(key)],
        // TODO: why backed doesn't allow to expand card_id?
        // 'card_id',
      ],
    };
    const core: Expand = base;
    const b2b: Expand = base;

    return this.resolve({b2b, core, key});
  }
}

export namespace PaymentExpandJrpc {
  export type ExpandedFields = {
    card: MaybeExpanded<CardApiModel>;
    course: MaybeExpanded<CourseMapperJrpc.ExpandedApiData>;
    offer: MaybeExpanded<OfferMapperJrpc.ExpandedApiData>;
    refunds: MaybeExpanded<RefundMapperJrpc.ExpandedApiData>[];
    user: Expanded<UserMapperJrpc.ExpandedApiData, 'name'>;
  };
}
